<template>
  <layout-auth
    :message="message"
    :width="960"
  >
    <div v-if="isWebinarOpen">
      <div class="flex">
        <div style="width: 450px">
          <h3 class="special--heading">Sign up today and get...</h3>

          <ul class="special--list">
            <li
              class="special--list--item flex flex-between flex-vertical-center"
              v-for="(bullet,index) in special.bullets"
              :key="index"
            >
              <span>{{ bullet.text }}</span>
              <span class="special--list--item--value">({{ bullet.value }} value)</span>
            </li>
          </ul>
        </div>

        <div class="ml-200">
          <registration-form
            :billing-special="special.type"
            :billing-cycle="special.billingCycle"
            :billing-plan="special.plan"
            :coupon-code="special.coupon"
          ></registration-form>
        </div>
      </div>

      <p class="special--text" v-html="special.specialText">{{ special.specialText }}</p>
    </div>

    <template v-else>
      <p class="closed_message">This webinar special is no longer available. However, you can still sign up for
        Forefront.</p>

      <a href="https://forefrontcrm.com/pricing" class="button is-primary is-medium">Checkout Forefront Pricing</a>
    </template>
  </layout-auth>
</template>

<script>
import RegistrationForm from "./components/RegistrationForm";
import {BillingSpecials} from "../../services/billingSpecials";
import dates from "../../services/dates";

export default {
  name: "WebinarPage",
  components: {RegistrationForm},
  metaInfo: {
    title: "Register"
  },
  props: {},
  data() {
    return {
      specialKey: null,
    };
  },
  created() {
    this.specialKey = this.$route.path.substring(1);
    console.log("Route:", this.$route.path.substring(1));
  },
  computed: {
    special() {
      return BillingSpecials.findByRouterKey(this.specialKey);
    },
    message() {
      return this.isWebinarOpen ? "Webinar Special" : "Webinar Special Closed";
    },
    isWebinarOpen() {
      if (!this.special) {
        return false;
      }

      if (!this.special.isActive) {
        return false;
      }

      // If Close Date is not set, the its Still Open
      if (!this.special.closeDate) {
        return true;
      }

      return dates.isInFuture(this.special.closeDate);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.special {
  &--heading {
    font-size: $size-4;
    font-weight: bold;
    color: $primary;
  }

  &--list {
    margin: 1rem 0 1.5rem;

    &--item {
      padding: 6px 0;
      line-height: 1.3;

      &:not(:last-of-type) {
        border-bottom: 1px solid $border;
      }

      &--value {
        flex-basis: 120px;
        color: $primary;
        text-align: right;
      }
    }
  }

  &--text {
    margin-top: 12px;
    font-size: 1.375rem;
    line-height: 1.5;
    text-align: center;
  }
}

.closed_message {
  margin-bottom: 1rem;
  font-size: 1.25rem;
  line-height: 1.3;
}

.button {
  line-height: 2.5em;
}
</style>
